export const visitorConstants = {
  GET_OR_CREATE_ID: "VISITOR_GET_OR_CREATE_ID",
};